import React, { useState } from "react";
import { PageLayout } from "../components/page-layout";
import { MakeBid } from "../components/transfers/make-bid";
import { MyBids } from "../components/transfers/my-bids";
import { BuySell } from "../components/transfers/buy-sell";
import { ManageTeam } from "../components/transfers/manage-team";
import { TransfersBottomNavigation } from "../components/transfers/transfers-bottom-navigation";
import PremPlayersProvider from "../providers/premplayers-provider";
import SettledWindowTransactionsProvider from "../providers/settled-window-transactions-provider";
import UserPendingTransactionsProvider from "../providers/user-pending-tansactions-provider";

/*

Page contains 4 tabs:
1. Make Bid - Make a bid on a pot player. Uses premPlayersData and leaderboardData.
2. My Bids - View all bids made by the user. Uses premPlayersData, transactionsData and userPendingTransactionsData.
3. Buy/Sell - Buy and sell players. Uses premPlayersData, userPendingTransactionsData and leaderboardData.
4. Manage Team - Manage the user's team. Uses leaderboardData, premPlayersData and transactionsData.

premPlayersData is used in all tabs so create a context for it.

Data sources:
- * leaderboardData: List of all clubs, their players and their points. This is retrieved from the leaderboard context
- * premPlayersData: List of all players in the Premier League. This is retrieved from /prem-players
- transactionsData: List of all completed transactions in the current window. This is retrieved from /get-bids/current-window-settled
- userPendingTransactionsData: List of all pending transactions for the user. This is retrieved from /get-bids/club with clubId in the request body

*/


export const TransfersPage = () => {
  const [navValue, setNavValue] = React.useState(0);

  return (
    <PremPlayersProvider>
      <SettledWindowTransactionsProvider>
        <UserPendingTransactionsProvider>
          <PageLayout>
            {navValue == 0 && (
                <MakeBid setNavValue={setNavValue} />
            )}
            {navValue == 1 && (
                <MyBids />
            )}
            {navValue == 2 && (
                <BuySell />
            )}
            {navValue == 3 && (
                <ManageTeam />
            )}
            <TransfersBottomNavigation navValue={navValue} setNavValue={setNavValue} />
          </PageLayout>
        </UserPendingTransactionsProvider>
      </SettledWindowTransactionsProvider>
    </PremPlayersProvider>
  );
};
